module.exports = __webpack_public_path__ + "media/pages/assets/images/rising-line-2f7178aa90754d8709de554b0a131166.svg";